var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMumbai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2630,
    height: 1767,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-885 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.34 1255.22C3172.9 1742.48 2762.58 2049.92 2268.12 2049.92 1773.66 2049.92 1372.79 1694.14 1372.79 1255.22 1372.79 816.295 1771.56 423.918 2265.99 423.918 2760.42 423.918 2939.69 629.222 2971.34 1255.22",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.28 1984.78C1580.28 1984.78 1541.87 1852 1647.9 1731.12L1646.42 681.5 1827.43 681.743 1823.57 1730.12C1823.57 1730.12 1914.57 1806.18 1890.42 1986.5L1580.28 1984.8Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.5 680.5 1865.5 680.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.44 679.5C1840.44 679.5 1846.65 562.918 1735.35 488.5 1735.35 488.5 1631.18 541.52 1631.5 677.63",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.5 1452.5 1822.5 1451.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.5 1726.5 1822.5 1728.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.5 1075.5 1189.06 1075.5C1176.22 1075.5 1165.83 1085.89 1165.83 1098.71L1165.83 1159.71 1135.61 1160.83C1124.44 1161.24 1115.63 1170.39 1115.63 1181.56L1115.63 1349.23 1104.01 1353.57C1094.56 1357.12 1090.63 1368.31 1095.78 1376.98L1132.16 1438.03 1134.23 1986.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.5 1162.5 1165.5 1159.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.5 1198.5 1826.5 1195.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.5 1043.5 1826.5 1040.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.5 921.5 1826.5 919.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.5 836.5 1826.5 834.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.5 1351.5 1115.5 1349.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.5 1439.5 1132.5 1438.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 1985.63 1255.39 1655.69C1255.39 1655.69 1272.1 1540.85 1377.99 1503.5 1377.99 1503.5 1476.45 1544.62 1491.29 1643.66L1501.5 1987.5 1304.6 1986.02 1253.5 1985.63Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.5 1982.83 1963.54 1554.7C1963.54 1554.7 1988.77 1336.22 2194.57 1282.5 2194.57 1282.5 2377.22 1318.3 2426.96 1549.53L2430.5 1985.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.5 1983.5 1307.77 1797.61C1307.77 1797.61 1318.05 1759.51 1367.6 1746.5 1367.6 1746.5 1407.8 1762.3 1423.69 1797.61L1426.5 1980.71",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.5 1680.5 1489.5 1680.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2805.24 1986.48C2805.24 1986.48 2847.39 1852.5 2741.28 1731.56L2742.76 681.5 2561.62 681.743 2565.48 1730.57C2565.48 1730.57 2474.41 1804.23 2498.58 1984.63L2805.24 1986.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2785.5 680.5 2523.5 680.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2548.92 679.5C2548.92 679.5 2536.01 553.616 2653.83 488.5 2653.83 488.5 2755.75 527.579 2757.5 677.63",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2738.5 1452.5 2566.5 1451.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.5 1505.5 2566.5 1508.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.5 1726.5 1822.5 1728.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.5 1726.5 2566.5 1728.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2743.5 1075.5 3199.94 1075.5C3212.78 1075.5 3223.17 1085.92 3223.17 1098.74L3223.17 1159.81 3253.39 1160.93C3264.56 1161.34 3273.37 1170.52 3273.37 1181.69L3273.37 1349.53 3285 1353.91C3294.44 1357.45 3298.37 1368.67 3293.22 1377.34L3256.84 1438.44 3254.77 1987.5 2804.84 1981.92",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2743.5 1162.5 3223.5 1159.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.5 1351.5 3273.5 1349.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2743.5 1439.5 3256.5 1438.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3138.5 1984.55 3134.04 1655.06C3132.63 1645.46 3144.59 1550.29 3011.41 1503.5 3011.41 1503.5 2912.93 1544.44 2898.08 1643.08L2892.5 1985.5 3084.79 1984.02 3138.5 1984.55Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3084.5 1983.5 3080.78 1797.52C3080.78 1797.52 3070.54 1759.49 3021.18 1746.5 3021.18 1746.5 2981.13 1762.27 2965.3 1797.52L2962.5 1980.33",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3134.5 1680.5 2899.5 1680.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954.5 1041.5 1955.5 1146.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2109.5 1041.5 2110.5 1146.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2262.5 1041.5 2263.5 1146.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415.5 1041.5 2416.5 1146.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.5 1317C1984.5 1338.82 1966.59 1356.5 1944.5 1356.5 1922.41 1356.5 1904.5 1338.82 1904.5 1317 1904.5 1295.18 1922.41 1277.5 1944.5 1277.5 1966.59 1277.5 1984.5 1295.18 1984.5 1317Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484.5 1317C2484.5 1338.82 2466.59 1356.5 2444.5 1356.5 2422.41 1356.5 2404.5 1338.82 2404.5 1317 2404.5 1295.18 2422.41 1277.5 2444.5 1277.5 2466.59 1277.5 2484.5 1295.18 2484.5 1317Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.5 1987.5 3388.5 1987.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.5 1317C1984.5 1338.82 1966.59 1356.5 1944.5 1356.5 1922.41 1356.5 1904.5 1338.82 1904.5 1317 1904.5 1295.18 1922.41 1277.5 1944.5 1277.5 1966.59 1277.5 1984.5 1295.18 1984.5 1317Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.5 1505.5 1822.5 1508.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.5 1505.5 2566.5 1508.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMumbai);
export default __webpack_public_path__ + "static/media/mumbai.4413c967b908446fd7bac14e247e19de.svg";
export { ForwardRef as ReactComponent };